import React from "react";
import "./PoliticaDePrivacidade.css";
import ComponentHome1 from "../Home2/components/componentHome1";
import ComponentHome6 from "../Home2/components/componentHome6";
import FooterHome from "../Home2/components/FooterHome";
import Header from "../../components/Header";

const PoliticaDePrivacidade = () => {
  return (
    <>
      <Header />
    

      <div className="politica-container">
        <h1>Política de Privacidade</h1>

        <p>
          Esta Política de Privacidade descreve como suas informações pessoais
          são coletadas, usadas e compartilhadas quando você visita ou utiliza
          nosso site/aplicativo.
        </p>

        <h2>1. Informações que Coletamos</h2>
        <ul>
          <li>Dados fornecidos por você, como nome, e-mail e telefone;</li>
          <li>Informações de navegação, como endereço IP, tipo de navegador, tempo de acesso;</li>
          <li>Cookies e tecnologias semelhantes.</li>
        </ul>

        <h2>2. Como Usamos suas Informações</h2>
        <ul>
          <li>Melhorar a experiência do usuário;</li>
          <li>Enviar atualizações e comunicações importantes;</li>
          <li>Garantir a segurança e prevenir fraudes.</li>
        </ul>

        <h2>3. Compartilhamento de Dados</h2>
        <p>
          Não compartilhamos suas informações pessoais com terceiros, exceto nos
          casos previstos por lei ou quando necessário para o funcionamento do serviço.
        </p>

        <h2>4. Seus Direitos</h2>
        <ul>
          <li>Acessar, corrigir ou excluir seus dados pessoais;</li>
          <li>Retirar consentimento a qualquer momento;</li>
          <li>Solicitar informações sobre o uso de seus dados.</li>
        </ul>

        <h2>5. Segurança</h2>
        <p>
          Adotamos medidas de segurança apropriadas para proteger seus dados
          contra acessos não autorizados, alterações ou destruição.
        </p>

        <h2>6. Alterações</h2>
        <p>
          Esta política pode ser atualizada periodicamente. Recomendamos revisar
          esta página regularmente para estar ciente das mudanças.
        </p>

      </div>
      <FooterHome />
    </>
  );
};

export default PoliticaDePrivacidade;
